export const environment = {
  production: false,
  internalBase: 'https://nbrcui-alpha.azurewebsites.net/',
  portalApiBaseUrl: 'https://webapi-secure-alpha.azurewebsites.net/api/practitioner/',
  commonApiBaseUrl: 'https://webapi-secure-alpha.azurewebsites.net/api/common/',
  debugMode: false,
  // *** Alpha deployment of message center is stopped to save $$$ pointing to beta instead
  // messageCenterBaseUrl: 'https://mcalpha.nbrc.org',
  // messageCenterAppKey: 'fZxRJVACUZ9aTpo162F36JQJ',
  // messageCenterAppSecret: 'wElPEr0V2rz3Uv04yzgsWV0nha5DQ7OzLOcZ1JmrkA6xJsJrgNjAKPfII1FJyOy1',
  //messageCenterBaseUrl: 'https://mcbeta.nbrc.org',
  messageCenterBaseUrl: 'https://mcbetaapi.nbrc.org',
  messageCenterAppKey: 'LCWU0rrWRzM59NSG',
  messageCenterAppSecret: 'kgPX3SmvU2MTn7uUujzlQ05F1eUqEIB8YDxU8WDFiwVSYSXClWBGf5tOgon4m53f',

  //sandbox auth
  clientKey: '6Ay85xE9n3PcekR5pctpRa4M8U8WtLTTBd984d8aK3PYj5rZcC75GV9P825Ds7sR',
  apiLogin: '6B3v5Kkt',
  acceptJs: 'https://jstest.authorize.net/v1/Accept.js',
  //prod auth
  //clientKey: 'cIwhlaWKRO6633nH',
  //apiLogin: 'NBRC009',


  externalLinks: {
    nbrcHome: 'https://NBRC.org/',
    purchaseSAE: 'https://NBRC.org/resources/sae',
    practiceExam: 'https://NBRC.org/Free-Practice-Exams',
    contentOutlines: 'https://NBRC.org/resources/contentoutlines',
    candidateHandbook: 'https://www.nbrc.org/candidate-handbook',
    privacyPolicy: 'https://NBRC.org/privacy-statement/',
    termsOfUse: 'https://www.nbrc.org/terms-of-use/',
    contactUs: 'https://NBRC.org/contact'
  }
};
